import apiClient from '../client';

const STOCK_TRANSFER_BASE = `/digitization/v1/stock-transfer`;
const WAREHOUSE_BASE = `/traceability/v1/center/get_warehouse_list`;
const ORG_BASE = `/digitization/v1/organization/list`;
const PRODUCT_REPORT_BASE = `/digitization/v1/product/report`;

export const stockTransferApi = {
  createStockTransfer: data => apiClient.post(STOCK_TRANSFER_BASE, data),
  updateStockTransfer: (id, data) =>
    apiClient.put(`${STOCK_TRANSFER_BASE}/${id}`, data),
  getStockTransfer: id => apiClient.get(`${STOCK_TRANSFER_BASE}/${id}`),
  deleteStockTransfer: id => apiClient.delete(`${STOCK_TRANSFER_BASE}/${id}`),
  getStockTransferReport: params =>
    apiClient.post(`${STOCK_TRANSFER_BASE}/report`, params),
  getWarehouses: () => apiClient.get(WAREHOUSE_BASE),
  getOrganizations: () => apiClient.get(ORG_BASE),
  getProductReport: params => apiClient.post(PRODUCT_REPORT_BASE, params)
};

export default stockTransferApi;
